import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import ArrowIcon from "../../../../assets/icons/chevron.svg";
import { getLabelByValue } from "../../../../utils/getLabelByValue";
import { IReportCriteriasOptions } from "../../../../types/reportsInterfaces";

const formatDate = (newDate: string) => {
  const date = new Date(newDate);
  const options: { [key: string]: string } = {
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
  };
  const formattedDate = date.toLocaleDateString("ru-RU", options);
  return formattedDate;
};

const ReviewStatusTableSection: FC = () => {
  const { report, list } = useSelector(
    (state: any) => state.userSingleReport.userSingleReport
  );

  const [isFixedReportOpen, setIsFixedReportOpen] = useState<boolean>(false);
  const [isInternalReportRevisionOpen, setIsIntermalReportRevisionOpen] =
    useState<boolean>(false);
  const [isInternalReportImprovedOpen, setIsIntermalReportImprovedOpen] =
    useState<boolean>(false);
  const [isInternalReportApproveOpen, setIsIntermalReportApproveOpen] =
    useState<boolean>(false);
  const [isInternalReportRejectOpen, setIsIntermalReportRejectOpen] =
    useState<boolean>(false);
  const [isRejectedReportOpen, setIsRejectedReportOpen] =
    useState<boolean>(false);
    const [isVisibleData, setIsVisibleData] = useState<boolean>(true);

  const reasonOptions =
    list &&
    list.map((option: IReportCriteriasOptions) => ({
      value: option.reason.id || option,
      label: option.reason.name || option,
    }));
  reasonOptions &&
    reasonOptions.unshift({ value: 0, label: "Выберите причину" });

  useEffect(() => {
    const reportStatus =
      report && Object.keys(report?.reviewModel?.reviewStatus).toString();

    const statusActions: any = {
      Approved: {
        setState: setIsIntermalReportApproveOpen,
      },
      PartiallyRejected: {
        setState: setIsIntermalReportRejectOpen,
      },
      Revision: {
        setState: setIsIntermalReportRevisionOpen,
      },
      Improved: {
        setState: setIsIntermalReportImprovedOpen,
      },
      Rejected: {
        setState: setIsRejectedReportOpen,
      },
      Fixed: {
        setState: setIsFixedReportOpen,
      },
      NotChecked: {},
    };

    if (reportStatus) {
      resetSections();

      const statusAction = statusActions[reportStatus];

      if (!!Object.keys(statusAction).length) {
        statusAction.setState(true);
      }
    }
  }, [report, list]);

  const resetSections = () => {
    setIsIntermalReportImprovedOpen(false);
    setIsIntermalReportRevisionOpen(false);
    setIsIntermalReportApproveOpen(false);
    setIsIntermalReportRejectOpen(false);
    setIsRejectedReportOpen(false);
    setIsFixedReportOpen(false);
  };

  const reviewComment = report && report?.reviewModel?.reviewComment;
  const reviewerData = report && report?.reviewModel?.reviewer;
  const comment = report && report?.reviewModel?.comment;
  const fixDate = report && report.reviewModel.fixDate;
  const reason = report && report.reviewModel?.reason;
  const date = report && report?.reviewModel?.date;
  const reviewer = reviewerData
    ? `${reviewerData.familyName || ""} 
       ${reviewerData?.givenName || ""} 
       ${reviewerData?.middleName || ""} 
      (${reviewerData?.role})`
    : "Система";

  return (
    <div className={"customerReport__check_block"}>
      {isInternalReportApproveOpen && (
        <div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
          <span className="section__title">Проверка</span>
          <button
            className='sectionData_button'
            onClick={() => setIsVisibleData(!isVisibleData)}
          >
            <img src={ArrowIcon} alt="Custom Indicator" className='icon' />
          </button>
          <div className="customer__check_block">
            <div className="internal__check_elem">
              <span>Проверяющий:</span>
              <span>{reviewer}</span>
            </div>
            <div className="internal__check_elem">
              <span>Статус:</span>
              <span>
                <span className="approved__content">Утвержден</span>
              </span>
            </div>
            {comment && (
              <div className="internal__check_elem">
                <span>Комментарий:</span>
                <span>
                  <div className="disabled__revision_info">
                    <pre>{comment}</pre>
                  </div>
                </span>
              </div>
            )}
            <div className="internal__check_elem">
              <span>Дата:</span>
              <span>{formatDate(date)}</span>
            </div>
            {fixDate && (
              <div className="internal__check_elem">
                <span>Ожидаемая дата исправления:</span>
                <span>{formatDate(fixDate)}</span>
              </div>
            )}
          </div>
        </div>
      )}
      {isInternalReportRejectOpen && (
        <div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
          <span className="section__title">Проверка</span>
          <button
            className='sectionData_button'
            onClick={() => setIsVisibleData(!isVisibleData)}
          >
            <img src={ArrowIcon} alt="Custom Indicator" className='icon' />
          </button>
          <div className="customer__check_block">
            <div className="internal__check_elem">
              <span>Проверяющий:</span>
              <span>{reviewer}</span>
            </div>
            <div className="internal__check_elem">
              <span>Статус:</span>
              <span>
                <span className="approved__content">Отклонен частично</span>
              </span>
            </div>
            <div className="internal__check_elem">
              <span>Критерий:</span>
              <span>
                <pre>
                  {getLabelByValue(
                    (list && list)?.find(
                      (elem: IReportCriteriasOptions) => elem?.reason?.name === reason
                    )?.reason?.id,
                    reasonOptions
                  ) || reason}
                </pre>
              </span>
            </div>
            {comment && (
              <div className="internal__check_elem">
                <span>Комментарий:</span>
                <div className="reportCheck__info_block">
                  <pre>{comment}</pre>
                </div>
              </div>
            )}
            {reviewComment && (
              <div className="internal__check_elem">
                <span>Комментарий при проверке:</span>
                <span>
                  <input
                    className="internal__check_input"
                    type="text"
                    readOnly
                    disabled
                    defaultValue={reviewComment}
                  />
                </span>
              </div>
            )}
            <div className="internal__check_elem">
              <span>Дата:</span>
              <span>{formatDate(date)}</span>
            </div>
            {fixDate && (
              <div className="internal__check_elem">
                <span>Ожидаемая дата исправления:</span>
                <span>{formatDate(fixDate)}</span>
              </div>
            )}
          </div>
        </div>
      )}
      {isInternalReportRevisionOpen && (
        <div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
          <span className="section__title inside">Проверка</span>
          <button
            className='sectionData_button'
            onClick={() => setIsVisibleData(!isVisibleData)}
          >
            <img src={ArrowIcon} alt="Custom Indicator" className='icon' />
          </button>
          <div className="revision__check_block">
            <div className="internal__check_elem">
              <span>Проверяющий:</span>
              <span>{reviewer}</span>
            </div>
            <div className="internal__check_elem">
              <span>Статус:</span>
              <span>
                <span className="approved__content">Доработка</span>
              </span>
            </div>
            <div className="internal__check_elem">
              <span>Критерий:</span>
              <span>{reason}</span>
            </div>
            {comment && (
              <div className="internal__check_elem">
                <span>Комментарий:</span>
                <span>
                  <div className="disabled__revision_info">
                    <pre>{comment}</pre>
                  </div>
                </span>
              </div>
            )}
            <div className="internal__check_elem">
              <span>Дата:</span>
              <span>{formatDate(date)}</span>
            </div>
          </div>
        </div>
      )}
      {isInternalReportImprovedOpen && (
        <div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
          <span className="section__title inside">Проверка</span>
          <button
            className='sectionData_button'
            onClick={() => setIsVisibleData(!isVisibleData)}
          >
            <img src={ArrowIcon} alt="Custom Indicator" className='icon' />
          </button>
          <div className="revision__check_block">
            <div className="internal__check_elem">
              <span>Проверяющий:</span>
              <span>{reviewer}</span>
            </div>
            <div className="internal__check_elem">
              <span>Статус:</span>
              <span>
                <span className="approved__content">Доработан</span>
              </span>
            </div>
            <div className="internal__check_elem">
              <span>Критерий:</span>
              <span>{reason}</span>
            </div>
            {comment && (
              <div className="internal__check_elem">
                <span>Комментарий:</span>
                <span>
                  <div className="disabled__revision_info">
                    <pre>{comment}</pre>
                  </div>
                </span>
              </div>
            )}
            <div className="internal__check_elem">
              <span>Дата:</span>
              <span>{formatDate(date)}</span>
            </div>
            {fixDate && (
              <div className="internal__check_elem">
                <span>Ожидаемая дата исправления:</span>
                <span>{formatDate(fixDate)}</span>
              </div>
            )}
          </div>
        </div>
      )}
      {isRejectedReportOpen && (
        <div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
          <span className="section__title inside">Проверка</span>
          <button
            className='sectionData_button'
            onClick={() => setIsVisibleData(!isVisibleData)}
          >
            <img src={ArrowIcon} alt="Custom Indicator" className='icon' />
          </button>
          <div className="revision__check_block">
            <div className="internal__check_elem">
              <span>Проверяющий:</span>
              <span>{reviewer}</span>
            </div>
            <div className="internal__check_elem">
              <span>Статус:</span>
              <span>
                <span className="reject__content">Отклонен</span>
              </span>
            </div>
            <div className="internal__check_elem">
              <span>Критерий:</span>
              <span>{reason}</span>
            </div>
            {comment && (
              <div className="internal__check_elem">
                <span>Комментарий:</span>
                <div className="reportCheck__info_block">
                  <pre>{comment}</pre>
                </div>
              </div>
            )}
            <div className="internal__check_elem">
              <span>Дата:</span>
              <span>{report && formatDate(date)}</span>
            </div>
            {fixDate && (
              <div className="internal__check_elem">
                <span>Ожидаемая дата исправления:</span>
                <span>{formatDate(fixDate)}</span>
              </div>
            )}
          </div>
        </div>
      )}
      {isFixedReportOpen && (
        <div className={`sectionData ${isVisibleData ? 'sectionData_active' : ''}`}>
          <span className="section__title inside">Проверка</span>
          <button
            className='sectionData_button'
            onClick={() => setIsVisibleData(!isVisibleData)}
          >
            <img src={ArrowIcon} alt="Custom Indicator" className='icon' />
          </button>
          <div className="revision__check_block">
            <div className="internal__check_elem">
              <span>Проверяющий:</span>
              <span>{reviewer}</span>
            </div>
            <div className="internal__check_elem">
              <span>Статус:</span>
              <span>
                <span className="fixed__content">Исправлен</span>
              </span>
            </div>
            <div className="internal__check_elem">
              <span>Дата:</span>
              <span>{formatDate(date)}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewStatusTableSection;
